// extracted by mini-css-extract-plugin
export default {"back":"WorkspacePage_back__Vs3ap","loading":"WorkspacePage_loading__yc22p","blink":"WorkspacePage_blink__pY3Km"};